import styled from 'styled-components';

export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  &:last-child i {
    margin-right: 0;
    ${props => props.theme.mediaQueries.phone}{
      margin-right: 0.3em;
    }
  }
`;
